import React, { useState, useEffect } from 'react'
import Header from '../components/Header'
import HierarchyTree from '../components/HierarchyTree'
import { fetchAndBuildHierarchy } from '../utils/hierarchyBuilder'

export default function TeachersPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
     fetchAndBuildHierarchy('academics').then(res => {
         if (res) setData(res);
     });
  }, []);

  return (
    <div>
        <Header title="Our Teachers" />
        {data ? (
            <HierarchyTree 
                data={data} 
                title="Our Academic Faculty Leaders" 
                subtitle="ACADEMICS"
            />
        ) : (
            <div className="text-center py-5 text-muted">
                <p>Loading hierarchy or list is empty...</p>
            </div>
        )}
    </div>
  )
}
